import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import { evaluate, exportData } from "./vvinaleService";

const vvinaleSlice = createModule({
    name: "vvinale",
    initialState: {
        vvinales: [],
        isFetchingV: false,
        error: null
    },
    reducers: {
        evaluate: (state) => {
            state.isFetchingV = true;
        },
        save: (state) => {
            state.isFetchingV = true;
        },
        exportData: (state) => {
            state.isFetchingV = true;
        },
        list: (state) => {
            state.isFetchingV = true;
        },
        find: (state) => {
            state.isFetchingV = true;
        },

        fetchedData: (state, payload) => {
            state.vvinales = payload.body;
        },
        finishFetching: (state) => {
            state.isFetchingV = false;
        },
        fetchError: (state) => {
            state.isFetchingV = false;
            state.error = "An error occurred";
        },
    },
    sagas: (A) => ({

        *[A.evaluate]({ payload }) {
            try {
                const { data } = yield evaluate(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data.body);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.exportData]({ payload }) {
            try {
                const { data } = yield call(exportData, payload.data);

                // data = base64 string
                const base64 = data;
                const byteCharacters = atob(base64);
                const byteArrays = [];

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteArrays.push(byteCharacters.charCodeAt(i));
                }

                const fileBlob = new Blob([new Uint8Array(byteArrays)], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(fileBlob);

                // download the PDF
                const link = document.createElement("a");
                link.href = fileURL;
                link.download = "vvinale_export.pdf";
                link.click();

                yield put(A.finishFetching());
                if (payload?.onSuccess) yield call(payload.onSuccess);

            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        }
        // *[A.createVvinale]({payload}) {
        //     try {
        //         console.log(payload.data);
        //         yield createVvinale(payload.data);
        //         yield put(A.finishFetching());
        //         yield call(payload.onSuccess);
        //     } catch (e) {
        //         console.log(e);
        //         yield put(A.finishFetching());
        //         yield put(A.fetchError());
        //     }
        // },
        // *[A.listVvinale]() {
        //     try {
        //         const { data } = yield listVvinale();
        //         yield put(A.finishFetching());
        //         yield put(A.fetchedData(data));
        //     } catch (e) {
        //         console.log(e);
        //         yield put(A.finishFetching());
        //         yield put(A.fetchError());
        //     }
        // },
        // *[A.updateVvinale]({payload}) {
        //     try {
        //         yield updateVvinale(payload.data);
        //         yield put(A.finishFetching());
        //         yield call(payload.onSuccess);
        //     } catch (e) {
        //         console.log(e);
        //         yield put(A.finishFetching());
        //         yield put(A.fetchError());
        //     }
        // }

    })
})

export default vvinaleSlice;
export const vvinaleActions = vvinaleSlice.actions;
